import { _ as _sfc_main } from "./VaTimePickerColumnCell.vue_vue_type_script_lang-cdfb0e20.mjs";
import { openBlock, createElementBlock, normalizeStyle, renderSlot } from "vue";
import { _ as _export_sfc } from "../../../../plugin-vue_export-helper-cc2b3d55.mjs";
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    onMouseenter: _cache[0] || (_cache[0] = (...args) => _ctx.onMouseEnter && _ctx.onMouseEnter(...args)),
    onMouseleave: _cache[1] || (_cache[1] = (...args) => _ctx.onMouseLeave && _ctx.onMouseLeave(...args)),
    style: normalizeStyle(_ctx.styleComputed)
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 36);
}
const VaTimePickerColumnCell = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  VaTimePickerColumnCell as V
};
//# sourceMappingURL=VaTimePickerColumnCell-6efce04b.mjs.map
